import { BRAND_NAME, ROUTES, WORDPRESS_URL } from "@constants";
import { BUTTON_IDS } from "@features/dataLayer/buttonIds";
import { useTranslation } from "react-i18next";

export interface ILink {
    id: string;
    route: string;
    title: string;
    showNewBadge?: boolean;
}

export const useNavigationLinks = (): ILink[] => {
    const { t } = useTranslation("header");

    return [
        {
            id: BUTTON_IDS.TOP_NAV.GO_MOBILE,
            route: ROUTES.MOBILE_PAGE_URL,
            title: t("goMobile"),
        },
        {
            id: BUTTON_IDS.TOP_NAV.GO_BROADBAND,
            route: ROUTES.BROADBAND_PAGE_URL,
            title: t("goBroadband"),
            showNewBadge: true,
        },
        {
            id: BUTTON_IDS.TOP_NAV.ABOUT_GOMO,
            route: `${WORDPRESS_URL}/about-gomo/`,
            title: t("about", { brand: BRAND_NAME }),
        },
        {
            id: BUTTON_IDS.TOP_NAV.NEED_HELP,
            route: `${WORDPRESS_URL}/help-support/`,
            title: t("helpSupport"),
        },
    ];
};
